import React from "react";
import Select from "react-select";

const poolOptions = [
  {
    value: "INGRD",
    label: "Inground Pool"
  },
  {
    value: "NBRHD",
    label: "Neighborhood"
  },
  {
    value: "ABVGR",
    label: "Above ground Pool"
  }
];

const PoolFilter = ({ listingFilter, updateFilter }) => {
  const getPoolValues = selections => {
    if (!selections) return "";

    const selected = selections.map(s => poolOptions.find(p => p.value === s));
    return selected;
  };

  return (
    <div className="pt-2 pl-5 form-group row">
      <label
        className="col-form-label col-xl-4 col-md-4 pl-0 text-right"
        htmlFor="pool"
      >
        Pool
      </label>
      <div className="col-xl-8 col-md-8 pl-0 pr-0">
        <select
          name="pool"
          className="select custom-select range-select col-10"
          value={listingFilter.pool}
          onChange={event => updateFilter({ pool: event.target.value })}
        >
          <option value="">Any</option>
          <option value="NBRHD">Neighborhood</option>
          <option value="INGRD">Inground</option>
          <option value="ABVGR">Above Ground</option>
        </select>
      </div>
    </div>
  );
};

export default PoolFilter;
